import stockComponent from "@/components/stock/StockComponent.vue";
import AdminInventorySubMenusLinks from "@/components/menu/sub-menus/inventory/AdminInventorySubMenusLinks.vue";
export default {
  name: "adminStockDetails",
  data: function data() {
    return {
      id_stock: null,
      countries: []
    };
  },
  created: function created() {
    this.id_stock = this.$route.params.idStock;
    this.searchCriterias = this.$route.params.searchCriterias;
    this.countries = this.$route.params.countries;
  },
  components: {
    stock: stockComponent,
    AdminInventorySubMenusLinks: AdminInventorySubMenusLinks
  },
  props: ["loggedUserData"],
  methods: {}
};